import React from 'react';
import { Overlay, Spinner, Label, FontWeights } from '@fluentui/react';

interface LoadingOverlayProps {
    isVisible: boolean;
    theme: any;
    styles: any;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ isVisible, theme, styles }) => {
    if (!isVisible) return null;

    return (
        <Overlay styles={{ root: styles.overlay }}>
            <div className={styles.spinnerContainer}>
                <Spinner size={3} />
                <Label styles={{ root: { fontSize: '16px', fontWeight: FontWeights.semibold, color: theme.palette.neutralDark } }}>
                    Načítám...
                </Label>
            </div>
        </Overlay>
    );
};
